import React from "react";
import SidebarLayout from "../shops/SidebarLayout";
import MarketingCampaigns from "./MarketingCampaigns";

const BusinessMarketingPage = () => {
  return (
    <SidebarLayout>
      <div className="marketing-page">
        <MarketingCampaigns />
      </div>
    </SidebarLayout>
  );
};

export default BusinessMarketingPage;
